import { useHead } from '@unhead/vue';
import { get } from 'lodash';

type BreadcrumbData = App.Base.Data.BreadcrumbData;

export function usePageMeta(): {
  breadcrumbs: ComputedRef<BreadcrumbData[]>;
  currentRoute: ComputedRef<string | undefined>;
  headline: ComputedRef<string>;
  title: ComputedRef<string>;
  baseTitle: ComputedRef<string>;
} {
  const dialog = useDialog();
  const properties = useProperties() as {
    meta: App.Base.Data.PageMetaData;
  };
  const { current } = useRoute();

  const title = computed(() => {
    return (get(dialog.properties.value, 'meta.title') ?? properties.meta?.title ?? '') as string;
  });

  const headline = computed(() => {
    return properties.meta?.headline ?? '';
  });

  const baseTitle = computed(() => {
    return properties.meta?.title ?? '';
  });

  const breadcrumbs = computed(() => {
    const dialogBreadcrumbs = (dialog.properties.value?.breadcrumbs ?? []) as BreadcrumbData[];

    if (dialogBreadcrumbs.length > 0) {
      return dialogBreadcrumbs as BreadcrumbData[];
    }

    return properties.meta?.breadcrumbs ?? [];
  });

  const currentRoute = computed(() => {
    return current.value;
  });

  useHead({
    title
  });

  return {
    baseTitle,
    breadcrumbs,
    currentRoute,
    headline,
    title
  };
}
